<template>
    <div class="stock_print">
        <div class="print_header">
            <div class="back_btn" @click="$router.back()">
                <van-icon name="arrow-left" size="24" />
            </div>
            <span class="print_title">标签打印</span>
            <div class="placeholder"></div>
        </div>

        <div class="print_content">
            <!-- 选择类型 -->
            <div class="type_select" v-if="!$route.query.id">
                <div class="select_tabs">
                    <div class="tab" :class="{active:activeTab=='product'}" @click="switchTab('product')">产品</div>
                    <div class="tab" :class="{active:activeTab=='material'}" @click="switchTab('material')">物料</div>
                </div>
                
                <div class="search_row">
                    <div class="search_box">
                        <van-icon name="search" size="20" color="#999" />
                        <input type="text" v-model="searchName" :placeholder="activeTab === 'product' ? '产品名称' : '物料名称'" @input="onSearch">
                    </div>
                    <div class="search_box">
                        <van-icon name="search" size="20" color="#999" />
                        <input type="text" v-model="searchCode" :placeholder="activeTab === 'product' ? '产品编码' : '物料编码'" @input="onSearch">
                    </div>
                </div>

                <!-- 统计 -->
                <div class="stat_bar">
                    <div class="stat_item">
                        <span class="stat_value">{{stat.total}}</span>
                        <span class="stat_text">总记录</span>
                    </div>
                </div>

                <div class="select_list">
                    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                        <van-list
                            v-model="loading"
                            :finished="finished"
                            finished-text="没有更多了"
                            loading-text="加载中..."
                            @load="onLoad"
                        >
                            <van-checkbox-group v-model="selectedIds">
                                <div class="select_item" v-for="(item, idx) in list" :key="item.id">
                                    <div class="item_checkbox">
                                        <van-checkbox :name="item.id" shape="square" :ref="el => setCheckboxRef(el, idx)"></van-checkbox>
                                    </div>
                                    <div class="item_content" @click="toggleCheckbox(idx)">
                                        <img :src="item.imgs | getFirstImg" alt="" @error="handleImgError">
                                        <div class="item_info">
                                            <div class="name">{{item.name}}</div>
                                            <div class="code_text">编码: {{item.code}}</div>
                                            <!-- <div class="stock">库存: <span :class="{low: item.stock_num < 10}">{{item.stock_num || 0}}</span></div> -->
                                        </div>
                                    </div>
                                </div>
                            </van-checkbox-group>
                            
                            <div class="empty_tip" v-if="!loading && list.length === 0">
                                <img src="/static/imgs/no_data.jpg" alt="">
                                <span>暂无数据</span>
                            </div>
                        </van-list>
                    </van-pull-refresh>
                </div>
            </div>

            <!-- 单个打印预览 -->
            <div class="single_preview" v-else-if="detail.id">
                <div class="preview_card">
                    <div class="label_preview fixed_ratio" id="printArea">
                        <!-- Logo -->
                        <div class="preview_logo">
                            <img src="/static/imgs/icon.png" alt="LOGO" />
                        </div>
                        <!-- 类型标签 -->
                        <div class="preview_type">{{type === 'product' ? '产品' : '物料'}}</div>
                        <!-- 顶部分隔线 -->
                        <div class="preview_divider top"></div>
                        <!-- 主体内容 -->
                        <div class="preview_body">
                            <div class="preview_info">
                                <div class="preview_name" :class="getNameSizeClass(detail.name)">{{detail.name}}</div>
                                <div class="preview_code" :class="getCodeSizeClass(detail.code)">{{detail.code}}</div>
                                <div class="preview_hint">扫描右侧二维码溯源</div>
                            </div>
                            <div class="preview_qr">
                                <img :src="getQrCode(detail.qrcode_key || detail.code, detail.id, type)" alt="二维码" />
                            </div>
                        </div>
                        <!-- 底部分隔线 -->
                        <div class="preview_divider bottom"></div>
                        <!-- 时间 -->
                        <div class="preview_time">{{currentTime}}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部操作 -->
        <div class="print_footer" v-if="!$route.query.id">
            <div class="select_all">
                <van-checkbox v-model="selectAll" @change="toggleSelectAll" shape="square"></van-checkbox>
                <span class="select_all_text">全选</span>
                <span class="select_count">已选择 {{selectedIds.length}} 项</span>
            </div>
            <div class="print_btn" @click="previewBatchPrint">
                <van-icon name="printer" size="24" color="#fff" />
                <span>预览打印</span>
            </div>
        </div>

        <!-- 图片预览弹窗 -->
        <van-popup v-model="showImagePreview" round closeable style="width: 90%; max-height: 85vh;">
            <div class="image_preview_dialog">
                <div class="preview_title">
                    标签预览 
                    <span v-if="batchImageUrls.length > 1" class="image_counter">
                        ({{ currentImageIndex + 1 }} / {{ batchImageUrls.length }})
                    </span>
                </div>
                <div class="preview_image_container">
                    <img :src="previewImageUrl" alt="标签预览" class="preview_image" id="previewImage">
                    
                    <!-- 批量打印时的左右切换按钮 -->
                    <div v-if="batchImageUrls.length > 1" class="image_nav">
                        <div class="nav_btn prev" @click="prevImage" v-show="currentImageIndex > 0">
                            <van-icon name="arrow-left" size="24" />
                        </div>
                        <div class="nav_btn next" @click="nextImage" v-show="currentImageIndex < batchImageUrls.length - 1">
                            <van-icon name="arrow" size="24" />
                        </div>
                    </div>
                </div>
                
                <!-- 打印提示 -->
                <div class="preview_tips">
                    <p><strong>打印步骤：</strong></p>
                    <p>1. 点击"打开微打"跳转到下载页</p>
                    <p>2. 下载安装微打APP</p>
                    <p>3. 长按上方图片保存到相册</p>
                    <p>4. 打开微打APP选择图片打印</p>
                </div>
                
                <div class="preview_actions">
                    <van-button type="default" block @click="showImagePreview = false">关闭</van-button>
                    <van-button 
                        v-if="batchImageUrls.length > 1"
                        type="success" 
                        block 
                        @click="downloadAllImages" 
                    >保存全部({{ batchImageUrls.length }}张)</van-button>
                    <van-button 
                        type="primary" 
                        block 
                        @click="openInBrowser" 
                    >打开微打</van-button>
                </div>
            </div>
        </van-popup>

        <!-- 单个打印底部 -->
        <div class="print_footer single" v-if="$route.query.id">
            <div class="print_setting">
                <div class="setting_item">
                    <span>打印份数</span>
                    <van-stepper v-model="printCount" min="1" max="99" />
                </div>
            </div>
            <div class="print_actions">
                <div class="action_btn primary" @click="openInBrowser">
                    <van-icon name="printer" size="24" color="#fff" />
                    <span>打开微打</span>
                </div>
            </div>
        </div>

        <!-- 批量打印预览弹窗 -->
        <van-popup v-model="showBatchPreview" round position="bottom" closeable>
            <div class="batch_preview">
                <div class="preview_title">批量打印预览 ({{selectedIds.length}}个标签)</div>
                <div class="preview_list" id="batchPrintArea">
                    <div class="print_label_item" v-for="(item, index) in selectedItems" :key="index">
                        <div :ref="el => setLabelRef(el, index)" class="label_preview fixed_ratio" :data-index="index">
                            <!-- Logo -->
                            <div class="preview_logo">
                                <img src="/static/imgs/icon.png" alt="LOGO" />
                            </div>
                            <!-- 类型标签 -->
                            <div class="preview_type">{{activeTab === 'product' ? '产品' : '物料'}}</div>
                            <!-- 顶部分隔线 -->
                            <div class="preview_divider top"></div>
                            <!-- 主体内容 -->
                            <div class="preview_body">
                                <div class="preview_info">
                                    <div class="preview_name" :class="getNameSizeClass(item.name)">{{item.name}}</div>
                                    <div class="preview_code" :class="getCodeSizeClass(item.code)">{{item.code}}</div>
                                    <div class="preview_hint">扫描右侧二维码溯源</div>
                                </div>
                                <div class="preview_qr">
                                    <img :src="getQrCode(item.qrcode_key || item.code, item.id, activeTab)" alt="二维码" @error="handleImgError" />
                                </div>
                            </div>
                            <!-- 底部分隔线 -->
                            <div class="preview_divider bottom"></div>
                            <!-- 时间 -->
                            <div class="preview_time">{{currentTime}}</div>
                        </div>
                    </div>
                </div>
                <div class="preview_actions">
                    <van-button type="default" block @click="showBatchPreview = false">取消</van-button>
                    <van-button type="danger" block @click="printViaApp(true)" :disabled="selectedItems.length === 0">APP打印</van-button>
                </div>
            </div>
        </van-popup>


    </div>
</template>

<script>
import studio_api from '@/api/teaching_studio_teaching_studio_api.js'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'

export default {
    name: 'StockPrint',
    data() {
        return {
            type: '',
            activeTab: 'product',
            searchName: '',
            searchCode: '',
            list: [],
            page: 1,
            each_page: 10,
            loading: false,
            finished: false,
            refreshing: false,
            isFetching: false,
            selectedIds: [],
            selectAll: false,
            checkboxRefs: [],
            detail: {},
            printCount: 1,
            batchPrintCount: 1,
            showBatchPreview: false,
            selectedItems: [],
            isBatchPrint: false,
            showImagePreview: false,
            previewImageUrl: '',
            batchImageUrls: [], // 批量打印的多个图片URL
            currentImageIndex: 0, // 当前显示的图片索引
            stat: {
                total: 0
            },
            qrCodeMap: {},  // 存储生成的二维码 data URL
            labelRefs: []   // 存储标签DOM引用
        }
    },
    computed: {
        currentDate() {
            let date = new Date()
            return `${date.getFullYear()}/${(date.getMonth()+1).toString().padStart(2,'0')}/${date.getDate().toString().padStart(2,'0')}`
        },
        currentTime() {
            let now = new Date()
            return `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}:${String(now.getSeconds()).padStart(2,'0')}`
        },
        qrCodeUrl() {
            if (!this.detail.qrcode_key && !this.detail.code) return ''
            let content = this.detail.qrcode_key || this.detail.code
            return this.getQrCode(content, this.detail.id, this.type)
        }
    },

    filters: {
        getFirstImg(imgs) {
            if (!imgs) return '/static/imgs/no_img.png'
            // 支持多张图片用逗号分隔
            if (imgs.includes(',')) {
                return imgs.split(',')[0]
            }
            return imgs
        }
    },
    mounted() {
        document.title = "标签打印"
        this.type = this.$route.query.type
        this.activeTab = this.type || 'product'
        
        if (this.$route.query.id) {
            this.getDetail()
        } else {
            this.getList()
        }
    },
    methods: {
        // 图片加载失败处理
        handleImgError(e) {
            // 隐藏图片，显示占位背景
            e.target.style.display = 'none'
            e.target.parentElement.classList.add('img_error')
        },
        // 计算名称字体大小
        getNameSizeClass(name) {
            const len = name?.length || 0
            if (len > 20) return 'name-xsmall'
            if (len > 14) return 'name-small'
            if (len > 8) return 'name-medium'
            return 'name-large'
        },
        // 计算编码字体大小
        getCodeSizeClass(code) {
            const len = code?.length || 0
            if (len > 14) return 'code-small'
            return 'code-normal'
        },

        // 切换标签
        switchTab(tab) {
            this.activeTab = tab
            this.page = 1
            this.list = []
            this.selectedIds = []
            this.selectAll = false
            this.finished = false
            this.searchName = ''
            this.searchCode = ''
            this.stat.total = 0
            this.getList()
        },

        // 搜索
        onSearch() {
            this.page = 1
            this.list = []
            this.finished = false
            this.getList()
        },

        // 重置搜索
        resetSearch() {
            this.searchName = ''
            this.searchCode = ''
            this.onSearch()
        },

        // 刷新
        onRefresh() {
            this.page = 1
            this.list = []
            this.finished = false
            this.loading = true
            this.getList()
        },

        // 加载更多
        onLoad() {
            if (this.finished || this.isFetching) {
                this.loading = false
                return
            }
            this.getList()
        },

        // 获取列表
        async getList() {
            if (this.isFetching) return
            this.isFetching = true
            this.loading = true
            
            try {
                let api = this.activeTab === 'product' ? studio_api.Teaching_studio_apiIotmaxProductListGet : studio_api.Teaching_studio_apiIotmaxMaterialListGet
                let params = {
                    app_id: this.$root.app_id,
                    page: this.page,
                    each_page: this.each_page
                }
                
                // 产品和物料的搜索参数
                if (this.activeTab === 'product') {
                    if (this.searchName) params.name = this.searchName
                    if (this.searchCode) params.code = this.searchCode
                } else {
                    if (this.searchName) params.keyword = this.searchName
                }
                
                let res = await api(params)
                
                if (res.errcode === 0) {
                    // 接口返回格式: {count: 3, list: [...]}
                    let list = res.other && res.other.list ? res.other.list : []
                    
                    if (this.page === 1) {
                        this.list = list
                    } else {
                        let newItems = list.filter(item => !this.list.some(existing => existing.id === item.id))
                        this.list = this.list.concat(newItems)
                    }
                    
                    // 统计
                    this.stat.total = res.other && res.other.count ? res.other.count : this.list.length
                    
                    if (list.length < this.each_page) {
                        this.finished = true
                    } else {
                        this.page++
                    }
                } else {
                    this.finished = true
                }
            } catch (e) {
                console.log('获取列表失败', e)
                this.finished = true
            } finally {
                this.$nextTick(() => {
                    this.isFetching = false
                    this.loading = false
                    this.refreshing = false
                })
            }
        },

        // 获取详情
        async getDetail() {
            let data = await studio_api.Teaching_studio_apiIotmaxStockDetailGet({ app_id: this.$root.app_id, id: this.$route.query.id, type: this.type })
            if (data.errcode === 0) {
                this.detail = data.other || {}
            }
        },

        // 全选
        toggleSelectAll(val) {
            if (val) {
                this.selectedIds = this.list.map(item => item.id)
            } else {
                this.selectedIds = []
            }
        },

        // 设置 checkbox ref
        setCheckboxRef(el, idx) {
            if (el) {
                this.checkboxRefs[idx] = el
            }
        },

        // 设置标签 ref
        setLabelRef(el, idx) {
            if (el) {
                this.labelRefs[idx] = el
            }
        },

        // 切换 checkbox
        toggleCheckbox(idx) {
            const checkbox = this.checkboxRefs[idx]
            if (checkbox) {
                checkbox.toggle()
            }
        },

        // 生成二维码URL - 扫码后跳转到详情页
        async generateQrCode(content, id, type) {
            if (!content) return ''
            
            // 构建详情页URL，扫码后可直接打开
            const currentUrl = window.location.href
            const baseUrl = currentUrl.split('#')[0] + '#/warehouse/detail'
            const params = new URLSearchParams()
            
            if (id && type) {
                params.append('type', type)
                params.append('id', id)
            }
            params.append('qrcode_key', content)
            
            const detailUrl = `${baseUrl}?${params.toString()}`
            
            try {
                // 使用 qrcode 库生成 data URL
                const dataUrl = await QRCode.toDataURL(detailUrl, {
                    width: 150,
                    margin: 1,
                    errorCorrectionLevel: 'M'
                })
                return dataUrl
            } catch (error) {
                console.error('生成二维码失败:', error)
                return ''
            }
        },
        
        // 获取二维码（从缓存或生成）
        getQrCode(content, id, type) {
            if (!content) return ''
            
            const key = `${content}_${id}_${type}`
            
            // 如果缓存中已有，直接返回
            if (this.qrCodeMap[key]) {
                return this.qrCodeMap[key]
            }
            
            // 异步生成并缓存
            this.generateQrCode(content, id, type).then(dataUrl => {
                if (dataUrl) {
                    this.$set(this.qrCodeMap, key, dataUrl)
                }
            })
            
            // 先返回空字符串，等待生成完成
            return ''
        },

        // 预览批量打印
        previewBatchPrint() {
            if (this.selectedIds.length === 0) {
                this.$toast('请选择要打印的标签')
                return
            }
            this.selectedItems = this.list.filter(item => this.selectedIds.includes(item.id))
            this.labelRefs = [] // 重置 refs
            this.showBatchPreview = true
        },

        // 下载标签图片
        async downloadLabel() {
            const element = document.getElementById('printArea')
            if (!element) return
            
            this.$toast.loading({ message: '生成中...', forbidClick: true })
            
            try {
                let canvas = await html2canvas(element, {
                    scale: 2,
                    backgroundColor: '#fff'
                })
                
                let link = document.createElement('a')
                link.download = `标签_${this.detail.code}.png`
                link.href = canvas.toDataURL('image/png')
                link.click()
                
                this.$toast.success('保存成功')
            } catch (error) {
                console.error(error)
                this.$toast('保存失败')
            }
        },

        // 下载批量标签
        async downloadBatchLabel() {
            this.$toast('已保存到相册')
            this.showBatchPreview = false
        },



        // 通过APP打印（生成图片并调起微打APP）
        async printViaApp(isBatch) {
            this.isBatchPrint = isBatch
            
            this.$toast.loading({ message: '生成标签中...', forbidClick: true, duration: 0 })
            
            try {
                let imageDataUrl
                
                if (isBatch) {
                    // 批量打印：为每个标签生成单独的图片
                    this.batchImageUrls = await this.generateBatchLabelImages()
                    this.currentImageIndex = 0
                    this.previewImageUrl = this.batchImageUrls[0] || ''
                } else {
                    // 单个打印：生成单张标签图片
                    this.batchImageUrls = []
                    this.currentImageIndex = 0
                    this.previewImageUrl = await this.generateSingleLabelImage()
                }
                
                this.$toast.clear()
                
                // 显示图片预览弹窗（所有平台统一）
                this.showImagePreview = true
                
            } catch (error) {
                console.error('生成标签失败', error)
                this.$toast('生成标签失败')
            }
        },

        // 生成单张标签图片 - 高清
        async generateSingleLabelImage() {
            const element = document.getElementById('printArea')
            if (!element) throw new Error('打印区域不存在')
            
            // 确保元素完全渲染
            await this.$nextTick()
            await new Promise(resolve => setTimeout(resolve, 100))
            
            const canvas = await html2canvas(element, {
                scale: 4,  // 提高清晰度
                backgroundColor: '#fff',
                useCORS: true,
                allowTaint: true,
                logging: false
            })
            
            return canvas.toDataURL('image/png', 1.0)
        },

        // 生成批量标签图片 - 直接对页面上渲染好的DOM截图
        async generateBatchLabelImages() {
            const imageUrls = []
            
            // 确保弹窗已经渲染完成
            await this.$nextTick()
            // 等待二维码加载完成
            await new Promise(resolve => setTimeout(resolve, 300))
            
            // 遍历所有标签DOM元素进行截图
            for (let i = 0; i < this.labelRefs.length; i++) {
                const labelEl = this.labelRefs[i]
                if (!labelEl) continue
                
                try {
                    const canvas = await html2canvas(labelEl, {
                        scale: 4,
                        backgroundColor: '#fff',
                        useCORS: true,
                        allowTaint: true,
                        logging: false,
                        width: labelEl.offsetWidth,
                        height: labelEl.offsetHeight
                    })
                    
                    imageUrls.push(canvas.toDataURL('image/png', 1.0))
                } catch (error) {
                    console.error(`截图标签 ${i} 失败:`, error)
                }
            }
            
            return imageUrls
        },

        // 保存图片到相册
        saveImageToAlbum(dataUrl) {
            return new Promise((resolve, reject) => {
                const isIOS = this.isIOS()
                
                // iOS设备：显示图片预览弹窗，让用户长按保存
                if (isIOS) {
                    this.previewImageUrl = dataUrl
                    this.showImagePreview = true
                    resolve()
                    return
                }
                
                // Android或普通浏览器：创建下载链接
                const link = document.createElement('a')
                link.download = `标签_${this.detail.code || '批量'}_${Date.now()}.png`
                link.href = dataUrl
                
                // 触发下载
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                
                this.$toast.success('图片已保存')
                
                setTimeout(resolve, 500)
            })
        },

        // 调起微打APP - 引导浏览器打开方式
        // 调起微打APP（已废弃，保留代码备用）
        launchWeidaApp() {
            const isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent)
            const isAndroid = /Android/i.test(navigator.userAgent)
            
            // 如果在微信中，提示用户在浏览器中打开
            if (this.isWechat()) {
                this.showBrowserOpenGuide(isIOS, isAndroid)
                return
            }
            
            // 尝试调起APP，同时检测是否成功
            let appOpened = false
            const checkVisibility = () => {
                if (document.hidden || document.webkitHidden) {
                    appOpened = true
                }
            }
            
            document.addEventListener('visibilitychange', checkVisibility)
            document.addEventListener('webkitvisibilitychange', checkVisibility)
            
            // 尝试打开微打APP
            if (isIOS) {
                // iOS: 尝试 Universal Link 或 URL Scheme
                window.location.href = 'https://www.detonger.com/app'
                setTimeout(() => {
                    window.location.href = 'detonger://'
                }, 100)
            } else if (isAndroid) {
                // Android: 尝试 Intent
                window.location.href = 'intent://print#Intent;scheme=detonger;package=com.detonger.weida;end'
            }
            
            // 延迟检测是否成功打开
            setTimeout(() => {
                document.removeEventListener('visibilitychange', checkVisibility)
                document.removeEventListener('webkitvisibilitychange', checkVisibility)
                
                if (!appOpened && !document.hidden) {
                    // APP未打开，显示下载提示
                    this.showWeidaDownloadGuide(isIOS, isAndroid)
                }
            }, 1500)
        },

        // 显示微打下载引导
        showWeidaDownloadGuide(isIOS, isAndroid) {
            const downloadUrl = isIOS 
                ? 'https://apps.apple.com/cn/app/%E5%BE%AE%E6%89%93/id1548923373'
                : 'https://www.detonger.com/download'
            
            this.$dialog.confirm({
                title: '未检测到微打APP',
                message: '打印标签需要安装【微打】APP\n\n您可以选择：\n1. 下载安装微打APP\n2. 保存图片后用其他方式打印',
                confirmButtonText: '下载微打APP',
                cancelButtonText: '取消',
                confirmButtonColor: '#4E89FF'
            }).then(() => {
                // 点击下载
                window.open(downloadUrl, '_blank')
            }).catch(() => {
                // 取消
            })
        },

        // 切换到上一张图片
        prevImage() {
            if (this.currentImageIndex > 0) {
                this.currentImageIndex--
                this.previewImageUrl = this.batchImageUrls[this.currentImageIndex]
            }
        },
        
        // 切换到下一张图片
        nextImage() {
            if (this.currentImageIndex < this.batchImageUrls.length - 1) {
                this.currentImageIndex++
                this.previewImageUrl = this.batchImageUrls[this.currentImageIndex]
            }
        },
        
        // 下载所有图片
        async downloadAllImages() {
            this.$toast.loading({ message: '正在保存...', forbidClick: true })
            
            for (let i = 0; i < this.batchImageUrls.length; i++) {
                const link = document.createElement('a')
                link.download = `标签_${i + 1}_${Date.now()}.png`
                link.href = this.batchImageUrls[i]
                link.target = '_blank'
                link.style.display = 'none'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                
                // 间隔一点时间避免浏览器阻止批量下载
                await new Promise(resolve => setTimeout(resolve, 200))
            }
            
            this.$toast.clear()
            this.$toast.success(`已保存 ${this.batchImageUrls.length} 张图片`)
        },

        // 在浏览器中打开微打
        openInBrowser() {
            window.location.href = 'https://detonger.com/WDBQP/'
        },

        // 复制文本到剪贴板
        copyToClipboard(text) {
            const input = document.createElement('textarea')
            input.value = text
            document.body.appendChild(input)
            input.select()
            document.execCommand('copy')
            document.body.removeChild(input)
            this.$toast('链接已复制')
        },

        // 检测是否为iOS
        isIOS() {
            return /iPad|iPhone|iPod/i.test(navigator.userAgent)
        },

        // 检测是否为Android
        isAndroid() {
            return /Android/i.test(navigator.userAgent)
        },

        // 下载预览图片
        downloadPreviewImage() {
            if (!this.previewImageUrl) return
            
            // iOS 无法自动下载，提示长按保存
            if (this.isIOS()) {
                this.$toast('iOS请长按图片选择"存储图像"保存')
                return
            }
            
            // Android 微信内置浏览器限制下载，提示长按保存
            if (this.isAndroid() && this.isWechat()) {
                this.$dialog.alert({
                    title: '保存图片',
                    message: '请长按上方图片，选择"保存到手机"或"保存图片"',
                    confirmButtonText: '我知道了',
                    confirmButtonColor: '#4E89FF'
                })
                return
            }
            
            // 普通浏览器尝试下载
            try {
                const link = document.createElement('a')
                link.download = `标签_${this.detail.code || '批量'}_${Date.now()}.png`
                link.href = this.previewImageUrl
                link.target = '_blank'
                link.style.display = 'none'
                
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                
                this.$toast.success('图片已下载')
            } catch (e) {
                console.error('下载失败', e)
                this.$toast('下载失败，请长按图片保存')
            }
        },

        // 检查是否微信环境
        isWechat() {
            return /MicroMessenger/i.test(navigator.userAgent)
        },


    }
}
</script>

<style scoped>
.stock_print {
    width: 100%;
    min-height: 100vh;
    background: #F6F6F6;
}

.print_header {
    width: 100%;
    height: 88px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    box-sizing: border-box;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.back_btn i {
    font-size: 40px;
    color: #333;
}

.print_title {
    font-size: 32px;
    font-weight: bold;
    color: #333;
}

.placeholder {
    width: 40px;
}

.print_content {
    padding: 20px;
    padding-bottom: 180px;
}

.type_select {
    background: #fff;
    border-radius: 16px;
    padding: 20px 0;
}

.select_tabs {
    display: flex;
    background: #f5f7fa;
    border-radius: 16px;
    padding: 8px;
    margin: 0 20px 24px;
}

.select_tabs .tab {
    flex: 1;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    color: #666;
    border-radius: 12px;
    transition: all 0.3s;
}

.select_tabs .tab.active {
    background: #fff;
    color: #4E89FF;
    font-weight: bold;
    box-shadow: 0 4px 12px rgba(78,137,255,0.15);
}

.search_row {
    display: flex;
    gap: 16px;
    padding: 0 20px;
    margin-bottom: 24px;
}

.search_box {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    height: 72px;
    background: #f5f7fa;
    border-radius: 36px;
    padding: 0 24px;
    box-sizing: border-box;
}

.search_box i {
    font-size: 28px;
    color: #999;
}

.search_box input {
    flex: 1;
    width: 100%;
    min-width: 0;
    margin-left: 12px;
    border: none;
    background: transparent;
    font-size: 26px;
    outline: none;
    color: #333;
}

.select_list {
    max-height: calc(100vh - 380px);
    overflow-y: auto;
    padding: 0 20px;
}

.select_item {
    display: flex;
    align-items: center;
    padding: 24px;
    margin-bottom: 20px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}

.item_checkbox {
    flex-shrink: 0;
    margin-right: 20px;
    font-size: 0;
}


.item_content {
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
}

.item_content {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
}

.item_content img {
    width: 100px;
    height: 100px;
    border-radius: 12px;
    object-fit: cover;
    margin-right: 20px;
    flex-shrink: 0;
    background: #f5f5f5;
}

.item_content .img_error {
    width: 100px;
    height: 100px;
    border-radius: 12px;
    background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
    position: relative;
    margin-right: 20px;
    flex-shrink: 0;
}

.item_content .img_error::before {
    content: '无图片';
    color: #999;
    font-size: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.preview_qr img {
    width: 200px;
    height: 200px;
    object-fit: contain;
}

.preview_qr .img_error {
    width: 200px;
    height: 200px;
    background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
    position: relative;
}

.preview_qr .img_error::before {
    content: '无图片';
    color: #999;
    font-size: 24px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.item_info .name {
    font-size: 28px;
    color: #333;
    line-height: 1.5;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.item_info .code_text {
    font-size: 22px;
    color: #999;
    margin-top: 12px;
    line-height: 1.4;
}

.item_info .stock .low {
    color: #F44336;
}


.stat_bar {
    display: flex;
    padding: 0 30px 24px;
    background: #fff;
}

.stat_item {
    display: flex;
    align-items: baseline;
    gap: 12px;
}

.stat_value {
    font-size: 32px;
    font-weight: bold;
    color: #4E89FF;
}

.stat_text {
    font-size: 24px;
    color: #999;
}

.empty_tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 100px 0;
}

.empty_tip img {
    width: 240px;
    height: 160px;
    object-fit: contain;
}

.empty_tip span {
    font-size: 26px;
    color: #999;
    margin-top: 20px;
}

.single_preview {
    display: flex;
    justify-content: center;
    padding: 40px 0;
}

.preview_card {
    background: #fff;
    border-radius: 16px;
    padding: 40px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
}

/* 标签预览样式 - 适配手机端 */
.label_preview {
    width: 100%;
    height: 56.67vw;  /* 60:40 比例 */
    background: white;
    border: 2px solid #000;
    position: relative;
    font-family: 'Segoe UI', 'PingFang SC', sans-serif;
    overflow: hidden;
    margin: 0 auto;
    max-width: 600px;
    max-height: 400px;
}

/* Logo */
.preview_logo {
    position: absolute;
    top: 4%;
    left: 5%;
    height: 100px;
    width: 100px;
    display: flex;
    align-items: center;
}

.preview_logo img {
    height: 100%;
    width: 100%;
    object-fit: contain;
}

/* 类型标签 */
.preview_type {
    position: absolute;
    top: 4%;
    right: 5%;
    font-size: 40px;
    font-weight: 700;
    color: #000;
    background: #fff;
    padding: 1.5vw 3vw;
    border-radius: 4px;
}

/* 分隔线 - 加粗加深以适应黑白打印 */
.preview_divider {
    position: absolute;
    left: 4%;
    right: 4%;
    height: 3px;
    background: #000;
}

.preview_divider.top { top: 30%; }
.preview_divider.bottom { bottom: 12%; }

/* 主体内容 */
.preview_body {
    position: absolute;
    top: 32%;
    left: 5%;
    right: 5%;
    bottom: 18%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.preview_info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2vw;
    padding-right: 3vw;
    min-width: 0;
}

.preview_name {
    font-weight: 700;
    color: #000;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.preview_name.name-large {
    font-size: 6.5vw;
}

.preview_name.name-medium {
    font-size: 5.5vw;
}

.preview_name.name-small {
    font-size: 4.5vw;
}

.preview_name.name-xsmall {
    font-size: 3.5vw;
}

.preview_code {
    color: #333;
    font-family: 'Courier New', monospace;
    padding: 2px 6px;
    border-radius: 3px;
    font-weight: 700;
    line-height: 1.2;
    word-break: break-all;
    overflow-wrap: break-word;
    max-width: 100%;
}

.preview_code.code-normal {
    font-size: 4.5vw;
}

.preview_code.code-small {
    font-size: 4vw;
}

/* 扫描提示 - 增大字体加深颜色 */
.preview_hint {
    font-size: 4vw;
    color: #000;
    font-weight: 600;
}

/* 二维码 */
.preview_qr {
    width:35%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    padding: 1vw;
    /* border: 2px solid #000; */
    border-radius: 4px;
    flex-shrink: 0;
    /* margin-top: 15px; */
}

.preview_qr img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

/* 时间 - 增大字体加深颜色 */
.preview_time {
    position: absolute;
    bottom: 0%;
    right: 5%;
    font-size: 5vw;
    color: #000;
    font-family: 'Courier New', monospace;
    font-weight: 700;
    padding: 1vw 2vw;
    border-radius: 3px;
}

/* 旧样式兼容 - 单个预览 */
.label_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 16px;
}

.label_type {
    font-size: 26px;
    font-weight: bold;
    color: #4E89FF;
}

.label_date {
    font-size: 22px;
    color: #999;
}

.label_body {
    display: flex;
    align-items: center;
}

.label_qrcode {
    width: 140px;
    height: 140px;
    margin-right: 20px;
}

.label_qrcode img {
    width: 100%;
    height: 100%;
}

.label_preview.small .label_qrcode {
    width: 100px;
    height: 100px;
}

.label_info {
    flex: 1;
}

.info_name {
    font-size: 30px;
    font-weight: bold;
    color: #333;
    margin-bottom: 12px;
    word-break: break-all;
}

.info_code {
    font-size: 24px;
    color: #666;
    margin-bottom: 8px;
}

.info_stock {
    font-size: 24px;
    color: #4E89FF;
}

.label_preview.small .info_name {
    font-size: 22px;
}

.label_preview.small .info_code {
    font-size: 18px;
}

.label_footer {
    text-align: center;
    padding-top: 12px;
    margin-top: 16px;
    border-top: 1px solid #ddd;
}

.label_footer span {
    font-size: 22px;
    color: #999;
}

.print_footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 24px 40px;
    box-shadow: 0 -4px 20px rgba(0,0,0,0.08);
    z-index: 100;
}

.print_footer:not(.single) {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.select_all {
    display: flex;
    align-items: center;
    gap: 16px;
}


.select_all_text {
    font-size: 26px;
    color: #333;
    font-weight: 500;
}

.select_count {
    font-size: 24px;
    color: #999;
}

.print_btn {
    height: 72px;
    padding: 0 40px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 28px;
}

.print_btn i {
    font-size: 32px;
    margin-right: 12px;
}

.print_setting {
    margin-bottom: 20px;
}

.setting_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 28px;
    color: #333;
}

.print_actions {
    display: flex;
    gap: 20px;
}

.action_btn {
    flex: 1;
    height: 80px;
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
}

.action_btn.secondary {
    background: #f5f5f5;
    color: #666;
}

.action_btn.primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #fff;
}

.action_btn i {
    font-size: 32px;
    margin-right: 12px;
}

.batch_preview {
    max-height: 70vh;
    display: flex;
    flex-direction: column;
    padding: 20px;
}

.preview_title {
    font-size: 28px;
    font-weight: bold;
    color: #333;
    text-align: center;
    margin-bottom: 20px;
    padding-top: 20px;
}

.preview_list {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
    padding: 16px 0;
    align-content: flex-start;
}

.print_label_item {
    width: 100%;
    max-width: 600px;
    background: #fff;
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    margin: 0 auto;
}

/* 固定比例标签 - 用于批量预览弹窗，与生成图片时一致 */
.label_preview.fixed_ratio {
    width: 100%;
    height: auto;
    aspect-ratio: 3/2;
}

/* 对于固定比例标签，使用vw单位相对于容器宽度
   600px宽度下: 1vw = 6px
   字体大小: 6.5vw=39px, 5.5vw=33px, 4.5vw=27px, 3.5vw=21px, 4vw=24px, 5vw=30px, 6.67vw=40px */
.label_preview.fixed_ratio .preview_logo {
    top: 4%;
    left: 5%;
    height: 25%;
    width: 16.67%;
}

.label_preview.fixed_ratio .preview_type {
    top: 4%;
    right: 5%;
    font-size: 6.67vw;
    padding: 1.5vw 3vw;
}

.label_preview.fixed_ratio .preview_divider.top {
    top: 30%;
}

.label_preview.fixed_ratio .preview_divider.bottom {
    bottom: 12%;
}

.label_preview.fixed_ratio .preview_body {
    top: 32%;
    left: 5%;
    right: 5%;
    bottom: 18%;
}

.label_preview.fixed_ratio .preview_info {
    gap: 2vw;
    padding-right: 3vw;
}

.label_preview.fixed_ratio .preview_name.name-large {
    font-size: 6.5vw;
}

.label_preview.fixed_ratio .preview_name.name-medium {
    font-size: 5.5vw;
}

.label_preview.fixed_ratio .preview_name.name-small {
    font-size: 4.5vw;
}

.label_preview.fixed_ratio .preview_name.name-xsmall {
    font-size: 3.5vw;
}

.label_preview.fixed_ratio .preview_code.code-normal {
    font-size: 4.5vw;
}

.label_preview.fixed_ratio .preview_code.code-small {
    font-size: 4vw;
}

.label_preview.fixed_ratio .preview_hint {
    font-size: 4vw;
}

.label_preview.fixed_ratio .preview_qr {
    width: 35%;
    padding: 1vw;
}

.label_preview.fixed_ratio .preview_time {
    bottom: 0%;
    right: 5%;
    font-size: 5vw;
    padding: 1vw 2vw;
}

.preview_actions {
    display: flex;
    gap: 20px;
    padding: 20px 0;
}

.preview_actions .van-button {
    flex: 1;
}

.batch_settings {
    padding: 0 20px 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;
}

.setting_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 28px;
    color: #333;
}

.label_num {
    font-size: 20px;
    color: #fff;
    background: #4E89FF;
    padding: 2px 8px;
    border-radius: 10px;
    margin-left: 8px;
}

/* 图片预览弹窗 */
.image_preview_dialog {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.image_preview_dialog .preview_title {
    font-size: 32px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
}

.image_counter {
    font-size: 24px;
    color: #999;
    font-weight: normal;
    margin-left: 12px;
}

.image_nav {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    pointer-events: none;
}

.nav_btn {
    width: 44px;
    height: 44px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
    pointer-events: auto;
}

.nav_btn:active {
    background: rgba(0, 0, 0, 0.7);
}

.preview_image_container {
    width: 100%;
    background: #f5f5f5;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.preview_image {
    max-width: 100%;
    max-height: 40vh;
    object-fit: contain;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    /* iOS长按保存需要 */
    -webkit-touch-callout: default;
    -webkit-user-select: none;
    pointer-events: auto;
}

.preview_tips {
    background: #FFF8E1;
    border-radius: 12px;
    padding: 16px 20px;
    margin-bottom: 20px;
    width: 100%;
}

.preview_tips p {
    font-size: 26px;
    color: #666;
    line-height: 1.8;
    margin: 0;
}

/* 图片预览弹窗按钮组 */
.image_preview_dialog .preview_actions {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.image_preview_dialog .preview_actions .van-button {
   padding: 10px;
}

</style>
